import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { OrganizationKeyDetails } from '../models/OrganizationKeyDetails';

export class OrganizationKeyDetailsMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): OrganizationKeyDetails {
    let parsedKeyValue: object | null;
    let parsedKeyMetadata: object | null;

    try {
      parsedKeyValue = JSON.parse(data.valueJson);
    } catch {
      parsedKeyValue = null;
    }

    try {
      const parsed = JSON.parse(data.metadata);
      parsedKeyMetadata = parsed && Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch {
      parsedKeyMetadata = null;
    }

    return new OrganizationKeyDetails(this.gqlIdEncoder.decode(data.id), data.shortDescription, parsedKeyValue, data.hasPrivateKey, parsedKeyMetadata);
  }
}
